import packageInfo from '../../../../package.json'
export const environment = {
  production: false,
  version: packageInfo.version,
  prices:{
    IVA_PERCENT: 21,// 21% IVA
    redsysConfig:{
      url: "https://sis-t.redsys.es:25443/sis/realizarPago", // POST
      Ds_SignatureVersion: "HMAC_SHA256_V1",
      Ds_Merchant_MerchantCode: "014440655",
      Ds_Merchant_Terminal:"001",
      redirectDomain:'http://localhost:4200',
    }
  },
  apiUrl:'https://api.qventanacode-develop.a2system.net',
  firebaseConfig:{
    apiKey: "AIzaSyDyfZ_xyCp3vHLW0fAoljwKlIzSDpc7-3I",
    authDomain: "qventanacode-develop.firebaseapp.com",
    projectId: "qventanacode-develop",
    storageBucket: "qventanacode-develop.appspot.com",
    messagingSenderId: "434693211697",
    appId: "1:434693211697:web:0ec54ff9f86c4ece9df710",
    region: 'europe-west1',
  },
  apiServer: {
    url: 'https://qventanacode-develop.a2system.net/',
    projectId: "qventanacode-develop"
  },
  appLink: 'https://qventanacode-develop.web.app/'
};

//AMBIENTE PROD
// export const environment = {
//   production: true,
//   firebaseConfig:{
//     apiKey: "AIzaSyCC0D0kZXI-n0TK2-0s1yCcQ7jd8rBdSg8",
//     //authDomain: "qventanacode.firebaseapp.com",
//     authDomain: "admin.qventana.com",
//     projectId: "qventanacode",
//     storageBucket: "qventanacode.appspot.com",
//     messagingSenderId: "473388707800",
//     appId: "1:473388707800:web:c373acfa328afd39b30cad"
//   },
//   apiServer: {
//     url: 'https://qventanacode.a2system.net/',
//     projectId: "qventanacode"
//   },
//   appLink: 'https://app.qventana.com/'
// };



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
 import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
